import { createStore } from 'vuex'

import brands from './modules/brands'
import colors from './modules/colors'
import storages from './modules/storages'
import products from './modules/products'

export default createStore({
    modules: {
        brands,
        colors,
        storages,
        products
    }
})
